import { ModuleWithProviders, NgModule } from '@angular/core';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
})
export class I2gNgPerformanceModule {
  static forRoot(): ModuleWithProviders<I2gNgPerformanceModule> {
    return {
      ngModule: I2gNgPerformanceModule,
    };
  }
}
